export default "__VITE_ASSET__BBlh3P1o__"